import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { CompteurState, state } from '@/modules/Outils/store/state';
import { getters } from '@/modules/Outils/store/getters';
import { mutations } from '@/modules/Outils/store/mutations';


const module: Module<CompteurState, RootState> = {
    state,
    mutations,
    getters,
};

export default module;
export type { CompteurState };

